module.exports = __webpack_public_path__ + "images/welzorgef5f30c41097048b0074f4c74a3a536f.png";